import React from "react";
import { OrgChartView } from "../../../quality/org-charts/view";

/**
 * HSE/KS Org Chart View - Organisasjonskart detaljer (ISO 9001:2015 kap. 5.3)
 */
export const HseKsOrgChartView = () => {
  return <OrgChartView />;
};

